import animSeemerRaysProd1Src from "@/assets/images/anim-seemer-rays-prod-1.png"
import animSeemerRaysProd2Src from "@/assets/images/anim-seemer-rays-prod-2.png"
import { IAnimationProps } from "@/components/animation/use-cases/AnimationPlayer"

export const animationData: Array<IAnimationProps> = [
  // Order Status
  {
    animationId: "order-status",
    scenes: [
      {
        omnichannel: "voice",
        voiceMessage: {
          avatar: "ellie",
          duration: 42, // max 59 - not actual seconds because it would take forever (:
          message:
            "Hi, this is Elizabeth Hartson. I placed an order at your Acme store location in South Carolina on June 18th and when I went to track it, it says that the order tracking number is incorrect. I don't know if I'm doing something wrong or I just wanna make sure that the order did go through as it was reshipped to my house. And I have the order number, it's FB002490103. If you give me a call back, my number is 908-255-7500. Thanks so much.",
          phone: "908-255-7500",
        },
      },
      {
        chatStarterDate: "Friday, 6 Jul 09:14 AM",
        identity: {
          agentName: "ACME AI Agent",
          chatImage: "acme",
          chatTitle: "ACME AI Agent",
          userName: "Elizabeth",
        },
        messageEntries: [
          {
            directive: {
              text: "Check Order Management and CRM systems to confirm order details, then provide helpful response",
            },
            message:
              "Hi Elizabeth - I'm your personal Acme AI agent and I'd like to help you with your order status request for FB002490103.  I see that the tracking number was missing a digit - your full tracking number is: 90128092 for future reference.",
            sender: "agent",
          },
          {
            directive: {
              text: "Check Shipping details and respond with correct tracking number",
            },
            message:
              "I apologize for the inconvenience but happy to report that your order is scheduled for delivery tomorrow!",
            sender: "agent",
          },
          {
            directive: {
              text: "Use info from Order Management system to confirm latest order status",
            },
            message: "Is there anything else I can help you with today?",
            sender: "agent",
          },
          {
            message:
              "That tracking number works great - thanks!  I think I'm good to go.",
            sender: "user",
          },
          {
            directive: {
              text: "Create direct, lasting relationships with your customers",
            },
            message:
              "Great!  A quick tip - I'm available 24/7/365 to assist you with your shopping needs. Simply save this number in your phone as a contact (Maybe under the name 'Coolest AI Assistant Ever'?) for the fastest and easiest way to get answers and updates from Acme going forward.",
            sender: "agent",
          },
          {
            metadata: {
              cta: "Save Contact",
              description: "Business Account",
              title: "ACME AI Agent",
              type: "contact",
            },
            sender: "agent",
          },
          {
            directive: {
              text: "Offer compliant opt-out option and sync with CRM",
            },
            message:
              "If I ever send you information that you don't find helpful, simply respond back letting me know it wasn't helpful, or respond with STOP. I'll either improve on my future communications or stop sending you texts based on your preference.",
            sender: "agent",
          },
        ],
        omnichannel: "sms",
      },
    ],
  },
  // Returns & Exchanges
  {
    animationId: "returns-exchanges",
    scenes: [
      {
        identity: {
          chatImage: "lumiere-belle",
          chatTitle: "Lumière Belle",
        },
        messageEntries: [
          {
            message:
              "Hi. I ordered the Orinda Maxi Dress in Small and it is too tight.",
            sender: "user",
          },
          {
            message:
              "I still have the tags on the dress and have never worn it, I was wondering if I could still exchange it for a medium?",
            sender: "user",
          },
          {
            message:
              "I really love this dress and am hoping I can still exchange.",
            sender: "user",
          },
          {
            directive: {
              text: "Check business policies and provide options in seconds",
            },
            message:
              "Hi Debbie! We're glad to hear that you love the Orinda Maxi Dress and we'd be happy to help you exchange it for a medium size.",
            sender: "agent",
          },
          {
            directive: {
              text: "Check eCommerce & Order Management systems and respond with helpful guidance",
            },
            message:
              "To initiate the exchange, please visit our Returns Center at https://dresses4u.happyreturns .com/ and enter your Order PO# (1477888) and ZIP code (WLKGT).",
            sender: "agent",
          },
          {
            message:
              "You can then select your new size (Medium) and then simply print the provided shipping label and drop it off in the next 48hrs at your nearest FedEx location.",
            sender: "agent",
          },
          {
            message:
              "If you have any questions or need further assistance, please don't hesitate to ask!",
            sender: "agent",
          },
        ],
        omnichannel: "web",
      },
      {
        chatStarterDate: "Tuesday, 4 Jul 11:35 AM",
        identity: {
          agentName: "AI Agent",
          chatImage: "lumiere-belle",
          chatTitle: "Lumière Belle AI Agent",
          userName: "Debbie",
        },
        messageEntries: [
          {
            directive: {
              text: "Set a reminder to check Order Management systems and provide proactive order updates",
            },
            message:
              "Hi Debbie, I just wanted to let you know that your return has been scanned by FedEx and is enroute to our facilities. I will let you know once it's received!",
            sender: "agent",
          },
          {
            message: "Thank you!",
            sender: "user",
          },
          {
            directive: {
              text: "Friendly and human-like experiences that reflect your brand's tone and style",
            },
            message:
              "Hi Debbie - your return has been processed. Thank you and I hope the new dress is a better fit!  Please let me know if I can help with anything else.",
            newDate: "Friday, 7 Jul 2:11 PM",
            sender: "agent",
          },
          {
            directive: {
              text: "Create direct, lasting relationships with your customers",
            },
            message:
              "Before I go, please be sure to save my contact information in your phone. I'm available 24/7/365 should you ever have additional questions!",
            sender: "agent",
          },
          {
            metadata: {
              cta: "Save Contact",
              description: "Business Account",
              title: "Lumière Belle",
              type: "contact",
            },
            sender: "agent",
          },
        ],
        omnichannel: "sms",
      },
    ],
  },
  // Order Issues
  {
    animationId: "order-issues",
    scenes: [
      {
        email: {
          avatar: "rachel",
          from: "Rachel",
          message:
            "<p>Hi, my name is <strong>Rachel</strong> and I placed an order with <u>Acme.com</u> that has an incorrect shipping address. My order number is <strong>155-8147</strong> and my phone number is <strong><em>707-321-5922</em></strong>. Thank you so much and I hope you have a great day.</p></br><p><strong>Rachel</strong></p>",
          phone: "202-555-0149",
          title: "Re: Order modification",
          to: "to AI Agent",
        },
        omnichannel: "email",
      },
      {
        chatStarterDate: "Thursday, 31 Jul 06:09 PM",
        identity: {
          agentName: "AI Agent",
          chatImage: "acme",
          chatTitle: "ACME AI Agent",
          userName: "Rachel",
        },
        messageEntries: [
          {
            directive: {
              text: "Retrieve customer and order information using your CRM and Order Management systems",
            },
            message:
              "Hi Rachel, I'm your personal Acme.com AI agent! I received your email and I'm here to help you update your shipping information for order number 155-8147.",
            sender: "agent",
          },
          {
            directive: {
              text: "Ensure customer data remains accurate & up-to-date",
            },
            message:
              "Can you please respond with the correct mailing address and include city, state, and zipcode?",
            sender: "agent",
          },
          {
            message:
              "The correct address is 1234 Red Robin Lane, Anaheim, CA 92807",
            sender: "user",
          },
          {
            directive: {
              text: "Directly update your Order Management system & provide updated tracking info in real-time",
            },
            message:
              "Great, thanks! Your order has been updated with your correct mailing address on Red Robin Lane and is scheduled to arrive next Tuesday.",
            sender: "agent",
          },
          {
            directive: {
              text: "Secure opt-in for future communications",
            },
            message:
              "You can track your order using this link: trackyourorder.acme.co/155-8147.  Please let me know if I can help with anything else!",
            sender: "agent",
          },
          {
            message:
              "One more question before I go - are you OK if I text you for relevant order updates and/or promotional ACME offers that match your personal style and preferences? Please type YES if ok or NO if you'd prefer no more communication from me.",
            sender: "agent",
          },
          {
            message: "Yes.",
            sender: "user",
          },
          {
            message: "Fantastic - thanks! Have a great day!",
            sender: "agent",
          },
        ],
        omnichannel: "sms",
      },
    ],
  },
  // Product Information
  {
    animationId: "product-information",
    scenes: [
      // order matters, they will be played back in this order
      {
        chatStarterDate: "Friday, 11 Aug 04:20 PM",
        identity: {
          agentName: "AI Agent",
          chatImage: "seemer-rays",
          chatTitle: "Seemer Rays",
          userName: "George",
        },
        messageEntries: [
          {
            message: "Do you have the latest Prizm Polarized Sunglasses?",
            sender: "user",
          },
          {
            directive: {
              text: "Check product catalogue and provide link to item",
            },
            metadata: {
              description: "11 colors",
              image: animSeemerRaysProd1Src,
              price: "$169.60",
              title: "Holbrook XL",
              type: "product",
            },
            sender: "agent",
          },
          {
            message: "Do you have them with the Radar EV frames?",
            sender: "user",
          },
          {
            metadata: {
              description: "4 colors",
              image: animSeemerRaysProd2Src,
              price: "$208.80",
              title: "Radar EV Path",
              type: "product",
            },
            sender: "agent",
          },
          {
            message:
              "Awesome! I found them for cheaper on another site - can you offer me any discount?",
            sender: "user",
          },
          {
            directive: {
              text: "Check business policies and recommend a resolution",
            },
            message:
              "I see - I can offer you free shipping + a 5% discount if you purchase the glasses in the next hour.",
            sender: "agent",
          },
          {
            message: "Any chance you can give me a 10% discount?",
            sender: "user",
          },
          {
            directive: {
              text: "Lookup specific exceptions based on LTV, loyalty programs, etc.",
            },
            message:
              "I can offer you free shipping + an 8% discount if you purchase the glasses in the next 30 min.",
            sender: "agent",
          },
          {
            message: "Okay! Adding them to my cart now!",
            sender: "user",
          },
          {
            directive: {
              text: "Use customer history to offer cross-sell / up-sell opportunities",
            },
            message:
              "Would you like to purchase a hard case to protect your glasses like you've done in the past?",
            sender: "agent",
          },
          {
            message: "Yes please!",
            sender: "user",
          },
          {
            directive: {
              text: "Create direct, lasting relationships with your customers",
            },
            message:
              "Great - I've added a hard case to your cart!  Please be sure to save my contact information in your phone.  I'm available 24/7/365 should you ever have additional questions!",
            sender: "agent",
          },
          {
            metadata: {
              cta: "Save Contact",
              description: "Business Account",
              title: "Seemer Rays",
              type: "contact",
            },
            sender: "agent",
          },
        ],
        omnichannel: "sms",
      },
    ],
  },
  // Product Support
  {
    animationId: "product-support",
    scenes: [
      {
        omnichannel: "voice",
        voiceMessage: {
          avatar: "johnny",
          duration: 32, // max 59 - not actual seconds because it would take forever (:
          message:
            "Hi, my name is John and I recently purchased a red, electric coffee mug from HotCups.com but, unfortunately, it has stopped taking a charge. Can you let me know what my options are to get a replacement?",
          phone: "202-555-0149",
        },
      },
      {
        chatStarterDate: "Thursday, 31 Aug 06:09 PM",
        identity: {
          agentName: "AI Agent",
          chatImage: "hot-cups",
          chatTitle: "HotCups AI Agent",
          userName: "John",
        },
        messageEntries: [
          {
            message:
              "Hi there - I'm your HotCups AI Agent and am happy to help with your options for replacing your red, electric coffee mug.  I'm sorry your mug has stopped working.",
            sender: "agent",
          },
          {
            directive: {
              text: "Find order using eCommerce platform",
            },
            message:
              "Can you first confirm that this is the order you're referring to - YFP901?",
            sender: "agent",
          },
          {
            message: "Yes - that's the one",
            sender: "user",
          },
          {
            directive: {
              text: "Check business policies and recommend a resolution",
            },
            message:
              "Perfect. It looks like your electric mug is within the 90 day warranty so I should be able to help you with a replacement mug! Would you like this item shipped to your home address on Red Robin Lane?",
            sender: "agent",
          },
          {
            message: "Yes please.",
            sender: "user",
          },
          {
            directive: {
              text: "Confirm resolution is satisfactory & escalate only if necessary",
            },
            message:
              "Great. Based on your location, I can get a replacement mug to you by next Thursday using standard shipping.  The total cost to you would be $4.99.  Is it OK to charge the credit card on file that ends in 99880?",
            sender: "agent",
          },
          {
            message: "Yes.",
            sender: "user",
          },
          {
            directive: {
              text: "Execute refund using payment system",
            },
            message:
              "Perfect. I've charged your card ending in 99880 a total of $4.99 and have processed a new order for your red, electric mug.  Your new order number is XYZ456 and your tracking number is 890123456. The package will arrive no later than next Thursday.",
            sender: "agent",
          },
          {
            message: "Awesome - thank you so much!",
            sender: "user",
          },
          {
            directive: {
              text: "Engaging, friendly, and human-like experience",
            },
            message:
              "That's what I'm here for!  Please feel free to text me 24/7/365 with any additional questions and THANK YOU for being a loyal HotCups customer!",
            sender: "agent",
          },
          {
            directive: {
              text: "Secure opt-in for future, personalized conversations",
            },
            message:
              "One more question before I go - are you OK if I text you for relevant order updates or promotional HotCups offers that match your personal style and preferences?  Please type YES if ok or NO if you'd prefer no more communication from me.",
            sender: "agent",
          },
          {
            message: "Yes.",
            sender: "user",
          },
          {
            directive: {
              text: "Create direct, lasting relationships with your customers",
            },
            message:
              "Fantastic - thanks! To make it even easier to get ahold of me, you can save my contact information in your phone. Have a great day!",
            sender: "agent",
          },
          {
            metadata: {
              cta: "Save Contact",
              description: "Business Account",
              title: "HotCups",
              type: "contact",
            },
            sender: "agent",
          },
        ],
        omnichannel: "sms",
      },
    ],
  },
]
